import { BehaviorSubject, Observable } from 'rxjs';

/* Used for hepling with state management
 * From this example: https://jurebajt.com/state-management-in-angular-with-observable-store-services/, https://github.com/jurebajt/rxjs-observable-store */
export abstract class Store<T> {
  state$: Observable<T>;
  private _state$: BehaviorSubject<T>;

  protected constructor(initialState: T) {
    this._state$ = new BehaviorSubject(initialState);
    this.state$ = this._state$.asObservable();
  }

  get state(): T {
    return this._state$.getValue();
  }

  setState(nextState: T): void {
    this._state$.next(nextState);
  }
}
